import { utils } from '@febos-io/common';

export const getCompanyClinicList = (companyId, page, limit = 1, filter = undefined) => ({
  path: `v1/companies/${companyId}/clinics`,
  params: {
    ...{ ...page && ({ page, }), },
    ...{ ...limit && ({ limit, }), },
    ...{ ...filter && ({ filter, }), },
  },
});

export const getCompanyClinicById = (companyId, identification) => ({
  path: `v1/companies/${companyId}/clinics/${identification}`,
});

export const createCompanyClinic = (
  companyId,
  {
    identification,
    name,
    status,
    logo,
    email,
    phone,
  }
) => ({
  path: `v1/companies/${companyId}/clinics`,
  method: utils.METHOD.POST,
  content: {
    identification,
    name,
    status,
    email,
    ...(phone && {
      phone,
    }),
    ...(logo && {
      logo,
    }),
  },
});

export const updateCompanyClinic = (
  companyId,
  clinicId,
  {
    identification,
    name,
    email,
    phone,
    logo,
  }
) => ({
  path: `v1/companies/${companyId}/clinics/${clinicId}`,
  method: utils.METHOD.PUT,
  content: {
    identification,
    name,
    email,
    ...(phone && {
      phone,
    }),
    ...(logo && {
      logo,
    }),
  },
});
